<template>
     <span class="span-form-control-feedback">
        <i v-if="Object.keys(this.errors).length && this.errors[field]" class="fa icon fas fa-exclamation-triangle"></i>
        <i v-if="Object.keys(this.errors).length && !this.errors[field]" class="fa icon fas fa-check"></i>
     </span>
</template>
<script>

    import {mapFields} from "vuex-map-fields";

    export default {
        name    : 'input-error',
        props   : {
            field: String
        },
        data() {
            return {};
        },
        methods : {},
        computed: {
            ...mapFields([
                'errors',
            ])
        },
        mounted() {
        },
    }
</script>
